// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eImageTicket {\n  display: -webkit-box;\n  -webkit-box-pack: center; /* justify-content */\n  -webkit-box-align: center;\n}\n\n.eFullImageIcon {\n  margin: 0 10px;\n}\n\n.eFullSizeImage {\n  min-width: 100%;\n  padding: 15px;\n}\n\n.mOverflowAuto {\n  overflow: auto !important;\n}\n\n.eImageFrame {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  margin-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
